import API from "api/API";
import useFetchData from "hooks/useFetchData";
import useAZZKULatestEditionID from "./useAZZKULatestEditionID";

export default function useAZZKUYears( params ) {
   const edition_id = useAZZKULatestEditionID();
   return useFetchData({
      APIMethod: API.getAZZKUYears,
      params: [ edition_id, params ],
      condition: !!edition_id,
      resultDataHandler: data => data.map( y => ({
         value: y,
         label: y
      }))
   })
}